/**
 * 将论坛会场 flat 列表按 dates 聚合为 TreeSelect 树形数据。
 * 结构：日期（不可选）→ 会场 → 子会场（若有 secondHallsList）
 * @param {Array<{ id: number, name: string, dates?: string, secondHallsList?: Array }>} flatHallList 接口返回的会场数组
 * @returns {{ treeData: Array, hallNameMap: Record<number, string> }} treeData 供 TreeSelect 使用；hallNameMap 供选中后回写名称
 */
export function buildForumHallTreeData(flatHallList) {
    const hallNameMap = {};
    if (!Array.isArray(flatHallList) || !flatHallList.length) {
        return { treeData: [], hallNameMap };
    }

    /** 按 dates 分组 */
    const byDate = {};
    for (const item of flatHallList) {
        const date = item.dates || '未设置日期';
        if (!byDate[date]) byDate[date] = [];
        byDate[date].push(item);
    }

    const treeData = Object.keys(byDate)
        .sort()
        .map(date => {
            const dateNode = {
                title: date,
                value: `date_${date}`,
                selectable: false,
                children: [],
            };

            for (const confHall of byDate[date]) {
                hallNameMap[confHall.id] = confHall.name;

                const subHalls = confHall.secondHallsList || [];
                if (subHalls.length > 0) {
                    const hallNode = {
                        title: confHall.name,
                        value: confHall.id,
                        selectable: false,
                        children: subHalls.map(sub => {
                            hallNameMap[sub.id] = sub.name;
                            return {
                                title: sub.name,
                                value: sub.id,
                            };
                        }),
                    };
                    dateNode.children.push(hallNode);
                } else {
                    dateNode.children.push({
                        title: confHall.name,
                        value: confHall.id,
                    });
                }
            }

            return dateNode;
        });

    return { treeData, hallNameMap };
}

/**
 * 为论坛树节点应用 disabled 状态：已被其他论坛块选中的会场不可再选（当前块已选值除外）。
 * @param {Array} treeData 原始树数据
 * @param {Set<number>} usedHallIds 已被占用的 hallsId 集合
 * @param {number|null|undefined} currentHallsId 当前论坛块已选 hallsId
 * @returns {Array}
 */
export function applyForumHallTreeDisabled(treeData, usedHallIds, currentHallsId) {
    if (!treeData?.length) return [];

    return treeData.map(dateNode => ({
        ...dateNode,
        children: (dateNode.children || []).map(hallNode => {
            if (hallNode.children?.length) {
                return {
                    ...hallNode,
                    children: hallNode.children.map(sub => ({
                        ...sub,
                        disabled: usedHallIds.has(sub.value) && sub.value !== currentHallsId,
                    })),
                };
            }
            return {
                ...hallNode,
                disabled: usedHallIds.has(hallNode.value) && hallNode.value !== currentHallsId,
            };
        }),
    }));
}
